'use strict';

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = (function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ('value' in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; })();

var _get = function get(_x, _x2, _x3) { var _again = true; _function: while (_again) { var object = _x, property = _x2, receiver = _x3; _again = false; if (object === null) object = Function.prototype; var desc = Object.getOwnPropertyDescriptor(object, property); if (desc === undefined) { var parent = Object.getPrototypeOf(object); if (parent === null) { return undefined; } else { _x = parent; _x2 = property; _x3 = receiver; _again = true; desc = parent = undefined; continue _function; } } else if ('value' in desc) { return desc.value; } else { var getter = desc.get; if (getter === undefined) { return undefined; } return getter.call(receiver); } } };

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError('Cannot call a class as a function'); } }

function _inherits(subClass, superClass) { if (typeof superClass !== 'function' && superClass !== null) { throw new TypeError('Super expression must either be null or a function, not ' + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _blacklist = require('blacklist');

var _blacklist2 = _interopRequireDefault(_blacklist);

var _classnames = require('classnames');

var _classnames2 = _interopRequireDefault(_classnames);

var _Radio = require('./Radio');

var _Radio2 = _interopRequireDefault(_Radio);

var RadioGroup = (function (_React$Component) {
    _inherits(RadioGroup, _React$Component);

    function RadioGroup() {
        _classCallCheck(this, RadioGroup);

        _get(Object.getPrototypeOf(RadioGroup.prototype), 'constructor', this).apply(this, arguments);
    }

    _createClass(RadioGroup, [{
        key: 'handleChange',
        value: function handleChange(e) {
            this.props.onChange(e.target.value, e);
        }
    }, {
        key: 'render',
        value: function render() {
            var self = this;

            // props
            var props = (0, _blacklist2['default'])(this.props, 'label', 'onChange', 'options', 'required', 'value');

            // classes
            var componentClass = (0, _classnames2['default'])(this.props.className);

            // dynamic elements
            var componentLabel = this.props.label ? _react2['default'].createElement(
                'label',
                { className: 'ComponentLabel' },
                this.props.label
            ) : null;

            // options
            var radios = this.props.options.map((function (radio, i) {
                return _react2['default'].createElement(_Radio2['default'], _extends({
                    key: 'radio-' + i,
                    id: radio.value + '-' + i,
                    inline: props.inline,
                    checked: radio.value === this.props.value,
                    onChange: self.handleChange.bind(this),
                    name: props.name,
                    size: props.size
                }, radio));
            }).bind(this));

            return _react2['default'].createElement(
                'div',
                _extends({ className: componentClass }, props),
                componentLabel,
                radios
            );
        }
    }]);

    return RadioGroup;
})(_react2['default'].Component);

RadioGroup.propTypes = {
    className: _propTypes2['default'].string,
    errors: _propTypes2['default'].arrayOf(_propTypes2['default'].string),
    inline: _propTypes2['default'].bool,
    label: _propTypes2['default'].oneOfType([_propTypes2['default'].string, _propTypes2['default'].node]),
    onChange: _propTypes2['default'].func.isRequired,
    options: _propTypes2['default'].array.isRequired,
    size: _propTypes2['default'].oneOf(['lg']),
    value: _propTypes2['default'].string
};

module.exports = RadioGroup;


//////////////////
// WEBPACK FOOTER
// /smarthelpnodeweb-ci-5863/workspace/Release_Build/~/kepler/lib/components/RadioGroup.js
// module id = 976
// module chunks = 0 1